import React from 'react';
import { takeLatest, call, put } from 'redux-saga/effects';
import dataApi from '../../apis/dataApi';
import * as constants from './constants';
import * as actions from './actions';
import * as act from '../PpsiContainer/actions';
import * as appAct from '../app/actions';
import handleError from '../handleError';
import { notify } from 'features/notificationSystem/actions';
import { setDataNotDirty } from 'features/app/actions';
import { FormattedMessage } from 'react-intl';

export function* fetchMarketSetting() {
  try {
    const response = yield call(dataApi.fetchMarketSetting);
    // if (response.data.localPPSIUtensils.length) {
    //   response.data.localPPSIUtensils = response.data.localPPSIUtensils.map(
    //     item => ({
    //       ...item,
    //       image: { thumbnailUrl: item.thumbnailUrl }
    //     })
    //   );
    // }
    yield put(actions.fetchMarketSettingsDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchMarketSettingsFail',
      put(actions.fetchMarketSettingsFail(error))
    );
  }
}

export function* saveMarketSetting(action) {
  const { payload, callback } = action;
  try {
    const response = yield call(dataApi.updateMarketSetting, payload);
    yield put(actions.saveMarketSettingsDone(response.data));
    yield put(actions.fetchMarketSettings());
    if (callback) {
      callback(true);
    }
    yield put(
      notify({
        message: [
          <FormattedMessage
            id="notify.saveMarketSettingsSuccess"
            key="success"
          />
        ],
        variant: 'success'
      })
    );

    yield put(appAct.fetchConfigsSeprately());
    // dispatch(setDataNotDirty());
  } catch (error) {
    if (error.response.data.message.includes('version')) {
      yield put(appAct.setDataNotDirty());
      yield put(act.hasRecalledPPSIError(true));
      yield put(actions.saveMarketSettingsFail(error));
    } else {
      yield call(
        handleError,
        error,
        error.response.data.message ? " " : 'notify.saveMarketSettingsFail',
        put(actions.saveMarketSettingsFail(error))
      );
    }
  }
}

export default [
  takeLatest(constants.FETCH_MARKET_SETTINGS, fetchMarketSetting),
  takeLatest(constants.SAVE_MARKET_SETTINGS, saveMarketSetting)
];
